<template>
  <Form
    :model="data"
    name="basic"
    layout="vertical"
    :label-col="{ span: 8 }"
    :wrapper-col="{ span: 16 }"
    autocomplete="off"
    @finish="onFinish"
    @finishFailed="onFinishFailed"
  >
    <Row :gutter="24" v-if="!isGroup">
      <Col :span="item.editSpan || 12" v-for="(item, index) in filterFun(list, type + 'Display')" :key="index">
        <template v-if="type === 'detail'">
          <h4 class="label">{{ item.label }}</h4>
          <template v-if="item.slot">
            <slot :name="item.prop"></slot>
          </template>
          <p v-else class="content">
            {{ formaterFun(item, data) || '--' }}
          </p>
        </template>
        <template v-else>
          <FormItem :name="item.prop" :label="item.label" :rules="item.rules" :required="item.required">
            <JtFormItem style="width: 100%" :searchParam="data" :item="item" v-model:value="data[item.prop]">
            </JtFormItem>
          </FormItem>
        </template>
      </Col>
    </Row>
    <template v-else>
      <Row v-for="(item, index) in filterFun(list, type + 'Display')" :key="index" :gutter="24">
        <Col :span="24" class="group-label">{{ item.label }}</Col>
        <template v-if="item.slot">
          <slot :name="item.prop"></slot>
        </template>
        <template v-else-if="type === 'detail'">
          <Col :span="k.detailSpan || 12" v-for="(k, i) in filterFun(item.column, 'detailDisplay')" :key="i">
            <h4 class="label">{{ k.label }}</h4>
            <p class="content" v-if="!k.slot">{{ formaterFun(k, data) || '--' }}</p>
            <template v-else>
              <slot :name="k.prop + 'view'"></slot>
            </template>
          </Col>
        </template>
        <template v-else>
          <Col :span="k.editSpan || 12" v-for="(k, i) in filterFun(item.column, 'editDisplay')" :key="i">
            <FormItem :name="k.prop" :label="k.label" :rules="k.rules" :required="k.required">
              <JtFormItem :searchParam="data" :item="k" v-model:value="data[k.prop]"> </JtFormItem>
            </FormItem>
          </Col>
        </template>
      </Row>
    </template>
    <button ref="submitBtn" type="primary" html-type="submit" v-show="false">Submit</button>
  </Form>
</template>
<script lang="ts" setup name="JtDetail">
  import { Row, Col, FormItem, Form } from 'ant-design-vue'
  import JtFormItem from '@jms/components/global/JtFormItem'
  import { ref } from 'vue'
  interface IListProps {
    list: Record<string, any>[]
    data: Record<string, any>
    isGroup: boolean
    type: string
  }
  defineProps<IListProps>()
  const emit = defineEmits(['onFinish', 'onFinishFailed'])
  const submitBtn = ref()
  const filterFun = (arr: Record<string, any>[], type: string) => {
    return arr.filter((item: Record<string, any>) => item[type] !== false)
  }
  const formaterFun = (item: Record<string, any>, data: Record<string, any>) => {
    return typeof item.formater === 'function'
      ? item.formater({ text: data[item.prop] || '', record: data })
      : data[item.prop]
  }
  const onFinish = (values: any) => {
    emit('onFinish', values)
  }

  const onFinishFailed = (errorInfo: any) => {
    emit('onFinishFailed', errorInfo)
  }
  const submit = () => {
    submitBtn.value.click()
  }
  defineExpose({
    submit
  })
</script>
<style scoped>
  .label {
    color: #808080;
  }
  .content {
    color: #3c3c3c;
  }
  .group-label {
    color: #3c3c3c;
    font-size: 16px;
    font-weight: 600;
    margin: 20px 0 10px;
  }
</style>
